import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/PresupuestoItem`

export function buscarTodos() {
  return http.get(`${API_ENDPOINT}/BuscarTodos/`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los presupuestos.',
      tipoError: 'presupuestos'
    }
  })
}

export function buscarPorId(idPresupuesto) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idPresupuesto}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener el presupuesto',
      tipoError: 'presupuestos'
    }
  })
}

export function buscarItemPorId(idPresupuesto) {
  return http.get(`${API_ENDPOINT}/BuscarItemPorId/${idPresupuesto}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener el presupuesto',
      tipoError: 'presupuestos'
    }
  })
}

export function insertar(presupuestoItem) {
  return http.post(API_ENDPOINT, presupuestoItem)
}

export function eliminar(presupuestoItem) {
  return http.post(`${API_ENDPOINT}/EliminarItem/`, presupuestoItem)
}
